import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { RequestCache } from "@app/core/shared/data/network/request-cache";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { MatchMapper } from "@app/core/match/data/network/match.mapper";
import { Match } from "@app/core/match/domain/model/match";
import { MatchSearchCriteria } from "@app/core/match/domain/match-search-criteria";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { MatchSearchCriteriaMapper } from "@app/core/match/data/network/match-search-criteria.mapper";
import { PaginatedResponse } from "@app/core/shared/domain/paginated-response";

@Injectable({
  providedIn: "root",
})
export class MatchWS {
  constructor(private handler: BaseHandler) {}
  execute(
    matchSearchCriteria: MatchSearchCriteria,
    token: string
  ): Observable<PaginatedResponse<Match[]>> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_MATCHES_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .setUrlParams(
        // It is necessary to serialize to put the parameters in such a way that the API accepts them
        MatchSearchCriteriaMapper.serialize(matchSearchCriteria)
      )
      .setCacheTtl(RequestCache.DEFAULT_TTL_MS)
      .build();

    return this.handler.execute(parameters).pipe(
      map((response) => ({
        data: response.matches_list.map(MatchMapper.deserialize),
        total: response.matches_total,
        returned: response.matches_returned,
      }))
    );
  }
}
